<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="page-content">
            <div class="container-fluid">

                <div class="row">
                    <div class="col-12 mb-4">
                        <v-card>

                            <v-card-title>
                                Historique de {{onceProduct.denomination}}

                                <v-spacer></v-spacer>
                                <v-text-field
                                        v-model="search"
                                        append-icon="mdi-magnify"
                                        label="Rechercher ..."
                                        single-line
                                        hide-details
                                ></v-text-field>
                                <v-btn @click="openDialog('Sortie')" class="mx-2" fab dark small color="red">
                                    <v-icon dark>mdi-minus</v-icon>
                                </v-btn>
                                <v-btn @click="openDialog('Entrée')" class="mx-2" fab dark small color="primary">
                                    <v-icon dark>mdi-plus</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-chip style="margin-left: 1.5%" color="blue" dark>
                                <span style="font-weight: bold">Quantité actuelle : {{pharmaproduits[0].qte}}</span>
                            </v-chip>

                            <v-data-table
                                    :headers="headers"
                                    :items="historiques"
                                    :search="search"
                                    sort-by="name"
                                    class="elevation-1"
                                    :loading="historiqueloading"
                                     loading-text="Chargement en cours...">

                                <template v-slot:item.type_operation="{ item }">
                                    <v-chip :color="getColor(item.type_operation)" dark>
                                        <span>{{item.type_operation.toUpperCase()}}</span>
                                    </v-chip>
                                </template>

                                <template v-slot:item.created_at="{item}">
                                    {{ getformatDate(item.created_at)}}
                                </template>

                                <template v-slot:top>
                                    <v-toolbar flat color="white">
                                        <v-spacer></v-spacer>
                                        <v-dialog v-model="dialog" max-width="500px">

                                            <v-card style="">
                                                <v-card-title>
                                                    <span class="headline"> {{text}} </span>
                                                </v-card-title>

                                                <v-card-text>
                                                    <v-form ref="form" v-model="valid" :lazy-validation="lazy">

                                                        <v-text-field v-if="submitting" color="primary" loading
                                                                      disabled></v-text-field>
                                                        <v-col cols="12" sm="12" md="12">

                                                            <v-container>
                                                                <v-row>
                                                                    <v-col cols="12" sm="12" md="12">
                                                                        <v-text-field
                                                                                :rules="qteRules"
                                                                                clearable
                                                                                v-model="editedItem.value_add"
                                                                                label="Quantité"
                                                                                placeholder="ex : 25"></v-text-field>

                                                                    </v-col>

                                                                </v-row>
                                                            </v-container>

                                                        </v-col>

                                                    </v-form>

                                                </v-card-text>

                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn color="blue darken-1" text @click="dialog=false">Annuler</v-btn>
                                                    <v-btn color="blue darken-1" :disabled="!valid" text @click="save">
                                                        Sauvegarder
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-toolbar>
                                </template>

                                <template v-slot:no-data>
                                    <v-btn color="default" @click="initialize">Vide, Actualiser</v-btn>
                                </template>
                            </v-data-table>
                        </v-card>
                    </div>
                </div>
                <v-snackbar
                        v-model="snackbar"
                        timeout="2000"
                >
                    {{ textSnack }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                                color="blue"
                                text
                                v-bind="attrs"
                                @click="snackbar = false"
                        >
                            Fermer
                        </v-btn>
                    </template>
                </v-snackbar>

            </div> <!-- container-fluid -->
        </div>
        <!-- End Page-content -->

    </div>
</template>

<script>
    import {mapState} from "vuex";
    // import $ from "jquery";


    export default {
        name: "Hsitorique",
        components: {},
        data() {
            return {
                submitting: false,
                valid: true,
                lazy: false,
                errors: {},
                search: '',
                dialog: false,
                id: undefined,
                snackbar: false,
                textSnack: '',
                text: '',
                e1: 1,
                editedIndex: -1,
                headers: [
                    {
                        text: 'Type d\'opération',
                        align: 'start',
                        sortable: true,
                        value: 'type_operation',
                    },
                    {text: 'Quantité', value: 'value_add'},
                    {text: 'Initiale', value: 'value_init'},
                    {text: 'Finale', value: 'value_final'},
                    {text: 'Par', value: 'user.name'},
                    {text: 'Date', value: 'created_at', sortable: false},

                ],
                editedItem: {
                    user: '',
                    type_operation: '',
                    value_add: '',
                    value_final: '',
                    value_init: '',
                    pharmaciechoose: '',
                    _id: 0,
                    created_at: 0,
                },
                onceProduct: {
                    reference: '',
                    denomination: '',
                    categorie_slug: '',
                    alt: '',
                    ci: '',
                    fp: '',
                    photo: undefined,
                    composition: [],
                    quantity: [],
                    cpd: "",
                    dc: "",
                    dosimetre: "",
                    dpa: "",
                    dps: "",
                    eacvum: "",
                    ei: "",
                    gs: "",
                    ic: "",
                    imafi: "",
                    ipr: "",
                    it: "",
                    le: "",
                    mgspe: "",
                    namm: "",
                    ncee: "",
                    pc: "",
                    pd: "",
                    pma: "",
                    ppc: "",
                    ppem: "",
                    sd: "",
                    tamp: "",
                    default_price: "",
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    user: '',
                    type_operation: '',
                    value_add: '',
                    value_final: '',
                    value_init: '',
                    pharmaciechoose: '',
                    _id: 0,
                    created_at: 0,
                },
                qteRules: [
                    v => !!v || 'Quantité requis',
                ]

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouveau" : "Mise à jour"
            }
            ,
            ...mapState('historiques/', ['historiques','historiqueloading']),
            ...mapState('pharmaproduits/', ['pharmaproduits']),
            ...mapState('produits/', [{produits:'oneproduits'}])

        }
        ,
        mounted() {

            console.log('The id is: ' + this.$route.params.id);
            this.editedItem.pharmaciechoose = this.$route.params.id;
            this.$store.dispatch('historiques/getHistoriques', this.$route.params.id).then(response => {
                window.console.log('historiques', response)
            });
            this.$store.dispatch('pharmaproduits/getOneChoose', this.$route.params.id).then(response => {
                window.console.log('pharmaproduits', response)
            });

            let data = new FormData();
            data.append("id", this.$route.params.prod);
            this.$store.dispatch('produits/getOnceProduits', data).then(response => {
                // window.console.log('produits', response.data.produits[0])
                this.onceProduct = response.data.produits[0];
            });

        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            },
            save() {


                let user = JSON.parse(localStorage.getItem("user"));

                this.submitting = true;
                let data = new FormData();
                data.append("user", user._id);
                data.append("type_operation", this.editedItem.type_operation);
                data.append("value_add", this.editedItem.value_add);
                data.append("value_init", this.pharmaproduits[0].qte);
                if (this.editedItem.type_operation=="Sortie")
                {
                    if (parseFloat(this.pharmaproduits[0].qte) < parseFloat(this.editedItem.value_add)) {
                        this.snackbar = true;
                        this.textSnack = "Quantité insuffisante";
                        this.submitting = false;
                        return;
                    }else{
                        data.append("value_final", (parseFloat(this.pharmaproduits[0].qte)-parseFloat(this.editedItem.value_add)));
                    }
                }else{
                    data.append("value_final", (parseFloat(this.pharmaproduits[0].qte)+parseFloat(this.editedItem.value_add)));
                }
                data.append("pharmaciechoose", this.pharmaproduits[0]._id);

                let mineroute = 'historiques/setHistorique';
                if (this.editedIndex > -1) {
                    data.append("id", this.editedItem._id);
                    mineroute = 'produits/setUpdateProduit';
                }
                /*console.log("ELE");
                console.log(this.pharmaproduits[0].qte);*/
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.submitting = false;
                    if (response.data.error) {
                        this.errors.operation = response.data.message;
                    } else {
                        this.reset();
                        this.dialog=false;
                        this.$store.dispatch('pharmaproduits/getOneChoose', this.$route.params.id).then(response => {
                            window.console.log('pharmaproduits', response)
                        });
                    }
                })
            },
            openDialog(type) {
                this.text = type;
                this.editedItem.type_operation = type;
                this.dialog = true;
            },
            getformatDate(value){
                if (value) {
                    return Intl.DateTimeFormat('en-US',{
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        hour: "numeric",
                        minute: "2-digit",
                        second: "2-digit"}).format(new Date(value));
                }
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },

            getColor(calories) {
                if (calories == "Sortie") return 'red'
                else return 'green'
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>